import React, { useState } from "react";
import { Flag, X } from "lucide-react";
import api, { apiError } from "@/lib/api";

/**
 * "Nahlásit inzerát" – uživatel napíše důvod a volitelně svůj e-mail.
 *
 * Props: listingId, listingTitle, onClose
 */
export default function ReportListingModal({ listingId, listingTitle, onClose }) {
  const [reason, setReason] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("stb_buyer_email") || "");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post(`/listings/${listingId}/report`, {
        reason: reason.trim(),
        sender_email: email.trim() || null,
      });
      setDone(true);
    } catch (ex) {
      setErr(apiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
      onClick={onClose}
      data-testid="report-modal"
    >
      <div className="stb-card p-5 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <h3 className="stb-h text-xl text-white inline-flex items-center gap-2">
            <Flag size={18} className="text-[#FF6B00]" /> Nahlásit inzerát
          </h3>
          <button onClick={onClose} className="text-[#A3A3A3] hover:text-white">
            <X size={18} />
          </button>
        </div>
        {done ? (
          <div className="mt-4 text-center" data-testid="report-done">
            <p className="stb-h text-[#22C55E] text-lg">Nahlášeno ✓</p>
            <p className="text-[#A3A3A3] text-sm mt-1">
              Díky! Provozovatel se na inzerát co nejdříve podívá.
            </p>
            <button onClick={onClose} className="stb-btn stb-btn-primary mt-4">Zavřít</button>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-3 space-y-2">
            <p className="text-xs text-[#A3A3A3]">
              Inzerát: <strong className="text-white">{listingTitle}</strong>
            </p>
            <textarea
              className="stb-input"
              rows={4}
              placeholder="Co je s inzerátem špatně? (podvod, špatná kategorie, nevhodný obsah…)"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
              minLength={2}
              maxLength={2000}
              data-testid="report-reason"
            />
            <input
              type="email"
              className="stb-input"
              placeholder="Tvůj e-mail (volitelné – pro doptání)"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="report-email"
            />
            {err && <p className="text-[#FF6B00] text-xs" data-testid="report-error">{err}</p>}
            <div className="flex gap-2 pt-1">
              <button
                type="submit"
                disabled={busy}
                className="stb-btn stb-btn-primary flex-1"
                data-testid="report-submit"
              >
                {busy ? "Odesílám…" : "Odeslat hlášení"}
              </button>
              <button type="button" onClick={onClose} className="stb-btn stb-btn-ghost">Zrušit</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
